module.exports = __webpack_public_path__ + "img/categoria-jardin.f1a67b58.png";